<template>
	<div 
		style="height:400px;overflow-y:scroll;" 
		class="w-100 mt-4">
		<div v-for="hour in hours"> 
		<div @click="openForm(hour)" class="mt-2 cursor-pointer text-center border-primary card">
		 <span class="text-primary py-2">{{hour}}</span>
		</div>
		</div>
	</div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { myCalendarService } from "@/_services";

export default { 
	data(){
		return {
			defaultHours: [
					'09:00',
					'09:30',
					'10:00',
					'10:30',
					'11:00',
					'11:30',
					'12:00',
					'12:30',
					'13:00',
					'13:30',
					'14:00',
					'14:30',
					'15:00',
					'15:30',
					'16:00',
					'16:30',
					'17:00',
					'17:30',
					'18:00'
				],
		}
	},
	methods:{
		openForm(hour){
			this.$emit('open',hour)
		}
	},
	props: {
    	hours: Array
    },
	created(){
		//this.getAvailabilityByDay(this.day,this.currentmonth,this.currentyear)
	},
	computed: {
		...mapState({
			headerTab: state => state.header.tab,
			isMenuCollapse: state => state.sidebar.isNavOpen, 
		}),
	},
 }
</script>